export const M1_UNIT_12 = {
  id: "u12-daily-routines",
  title: "Unidad 12: Daily Routines",
  topic: "Rutinas diarias y actividades",
  iconType: "schedule",
  grammarImage: "/u12-routines.jpg",
  grammarText: "Vocabulario de rutinas: wake up, get up, have breakfast, go to work, cook dinner, go to bed, etc.",
  sets: [
    // SET 1: Morning Routine (Rutina Matutina)
    {
      id: "u12-set1",
      title: "Set 1: Morning Routine",
      questions: [
        { type: "match", q: "Match the action", pairs: [{ left: "Open eyes", right: "Wake up" }, { left: "Leave bed", right: "Get up" }, { left: "Clean teeth", right: "Brush teeth" }], a: "completed" },
        { type: "mc", q: "First thing in the morning, I ___ up.", options: ["wake", "get", "stand"], a: "wake" },
        { type: "mc", q: "After waking up, I ___ out of bed.", options: ["get", "jump", "fall"], a: "get" },
        { type: "blank", q: "I need to ___ my teeth. (brush)", options: ["brush"], a: "brush" },
        { type: "mc", q: "I'm hungry! Let's ___ breakfast.", options: ["have", "do", "make"], a: "have" },
        { type: "blank", q: "I need to take a ___ to get clean. (shower)", options: ["shower"], a: "shower" },
        { type: "order", q: "Ordena: I wake up early.", words: ["I", "wake", "up", "early."], a: "I wake up early." },
        { type: "mc", q: "'Get dressed' means put on clothes. True?", options: ["True", "False"], a: "True" },
        { type: "blank", q: "I wash my ___ with water. (face)", options: ["face"], a: "face" },
        { type: "order", q: "Ordena: I brush my teeth.", words: ["I", "brush", "my", "teeth."], a: "I brush my teeth." }
      ]
    },
    // SET 2: Work & School (Trabajo y Escuela)
    {
      id: "u12-set2",
      title: "Set 2: Work & School",
      questions: [
        { type: "match", q: "Match destination", pairs: [{ left: "Adults", right: "Go to work" }, { left: "Children", right: "Go to school" }, { left: "Midday meal", right: "Have lunch" }], a: "completed" },
        { type: "mc", q: "I leave home to go to ___.", options: ["work", "bed", "sleep"], a: "work" },
        { type: "mc", q: "My kids go to ___ every morning.", options: ["school", "work", "gym"], a: "school" },
        { type: "blank", q: "I ___ work at 9:00 AM. (start)", options: ["start"], a: "start" },
        { type: "mc", q: "At 12:00 PM, I usually ___ lunch.", options: ["have", "do", "go"], a: "have" },
        { type: "blank", q: "I ___ work at 5:00 PM. (finish)", options: ["finish"], a: "finish" },
        { type: "order", q: "Ordena: I go to work.", words: ["I", "go", "to", "work."], a: "I go to work." },
        { type: "mc", q: "After work, I ___ home.", options: ["go", "start", "leave"], a: "go" },
        { type: "blank", q: "Do you ___ the bus to work? (take)", options: ["take"], a: "take" },
        { type: "order", q: "Ordena: School starts at 8.", words: ["School", "starts", "at", "8."], a: "School starts at 8." }
      ]
    },
    // SET 3: Evening Routine (Rutina de Tarde/Noche)
    {
      id: "u12-set3",
      title: "Set 3: Evening Routine",
      questions: [
        { type: "match", q: "Match evening activities", pairs: [{ left: "Prepare food", right: "Cook dinner" }, { left: "Eat food", right: "Have dinner" }, { left: "Clean plates", right: "Do the dishes" }], a: "completed" },
        { type: "mc", q: "It's time to ___ dinner.", options: ["cook", "do", "go"], a: "cook" },
        { type: "mc", q: "We ___ dinner together as a family.", options: ["have", "take", "sleep"], a: "have" },
        { type: "blank", q: "Can you help me ___ the table? (clear)", options: ["clear"], a: "clear" },
        { type: "mc", q: "It's my turn to ___ the dishes.", options: ["do", "make", "have"], a: "do" },
        { type: "blank", q: "I need to ___ the dog. (walk)", options: ["walk"], a: "walk" },
        { type: "order", q: "Ordena: We cook dinner together.", words: ["We", "cook", "dinner", "together."], a: "We cook dinner together." },
        { type: "mc", q: "I watch TV to relax. True?", options: ["True", "False"], a: "True" },
        { type: "blank", q: "Finally, I ___ to bed. (go)", options: ["go"], a: "go" },
        { type: "order", q: "Ordena: I go to sleep.", words: ["I", "go", "to", "sleep."], a: "I go to sleep." }
      ]
    },
    // SET 4: Time of Day (Momentos del Día)
    {
      id: "u12-set4",
      title: "Set 4: Time of Day",
      questions: [
        { type: "match", q: "Match time to name", pairs: [{ left: "Sunrise", right: "Dawn" }, { left: "12:00 PM", right: "Noon" }, { left: "Sunset", right: "Dusk" }], a: "completed" },
        { type: "mc", q: "We wake up in the ___.", options: ["morning", "night", "evening"], a: "morning" },
        { type: "mc", q: "Lunch is usually in the ___.", options: ["afternoon", "morning", "night"], a: "afternoon" },
        { type: "blank", q: "We watch TV in the ___. (evening)", options: ["evening"], a: "evening" },
        { type: "mc", q: "We sleep at ___.", options: ["night", "day", "noon"], a: "night" },
        { type: "blank", q: "12:00 AM is called ___. (midnight)", options: ["midnight"], a: "midnight" },
        { type: "order", q: "Ordena: Good morning!", words: ["Good", "morning!"], a: "Good morning!" },
        { type: "mc", q: "The sun is up during the ___.", options: ["day", "night", "evening"], a: "day" },
        { type: "blank", q: "See you in the ___. (afternoon)", options: ["afternoon"], a: "afternoon" },
        { type: "order", q: "Ordena: Have a good night.", words: ["Have", "a", "good", "night."], a: "Have a good night." }
      ]
    },
    // SET 5: Sequence Practice (Practicando la Secuencia)
    {
      id: "u12-set5",
      title: "Set 5: Daily Sequence",
      questions: [
        { type: "match", q: "Order the routine", pairs: [{ left: "1st", right: "Wake up" }, { left: "2nd", right: "Get up" }, { left: "3rd", right: "Shower" }], a: "completed" },
        { type: "mc", q: "First I wake up, then I ___ up.", options: ["get", "stand", "sit"], a: "get" },
        { type: "mc", q: "After breakfast, I ___ my teeth.", options: ["brush", "wash", "clean"], a: "brush" },
        { type: "blank", q: "I ___ dressed before work. (get)", options: ["get"], a: "get" },
        { type: "mc", q: "Routine: Wake -> Shower -> Breakfast -> Work. True?", options: ["True", "False"], a: "True" },
        { type: "blank", q: "Work -> Home -> Dinner -> ___ (Bed).", options: ["Bed"], a: "Bed" },
        { type: "order", q: "Ordena: First I wake up.", words: ["First", "I", "wake", "up."], a: "First I wake up." },
        { type: "mc", q: "I usually ___ dinner after work.", options: ["cook", "buy", "sell"], a: "cook" },
        { type: "blank", q: "I ___ the dog in the evening. (walk)", options: ["walk"], a: "walk" },
        { type: "order", q: "Ordena: Then I go to bed.", words: ["Then", "I", "go", "to", "bed."], a: "Then I go to bed." }
      ]
    },
    // SET 6: Shopping Routine (Rutina de Compras)
    {
      id: "u12-set6",
      title: "Set 6: Grocery Shopping",
      questions: [
        { type: "match", q: "Match shopping items", pairs: [{ left: "Food store", right: "Supermarket" }, { left: "Items to buy", right: "Groceries" }, { left: "Money", right: "Pay" }], a: "completed" },
        { type: "mc", q: "I need to buy food. I'm going to get ___.", options: ["groceries", "clothes", "shoes"], a: "groceries" },
        { type: "mc", q: "We usually go shopping at the ___.", options: ["supermarket", "library", "gym"], a: "supermarket" },
        { type: "blank", q: "I need to ___ groceries for the week. (buy)", options: ["buy"], a: "buy" },
        { type: "mc", q: "I go shopping ___ work.", options: ["after", "before", "during"], a: "after" },
        { type: "blank", q: "Let's ___ shopping! (go)", options: ["go"], a: "go" },
        { type: "order", q: "Ordena: I buy groceries.", words: ["I", "buy", "groceries."], a: "I buy groceries." },
        { type: "mc", q: "We need milk and bread. True?", options: ["True", "False"], a: "True" },
        { type: "blank", q: "Can you ___ the bags? (carry)", options: ["carry"], a: "carry" },
        { type: "order", q: "Ordena: Let's go to the market.", words: ["Let's", "go", "to", "the", "market."], a: "Let's go to the market." }
      ]
    },
    // SET 7: Review - Morning vs Evening (Repaso Matutino vs Vespertino)
    {
      id: "u12-set7",
      title: "Set 7: Morning vs Evening",
      questions: [
        { type: "match", q: "When do you do it?", pairs: [{ left: "Breakfast", right: "Morning" }, { left: "Lunch", right: "Afternoon" }, { left: "Dinner", right: "Evening" }], a: "completed" },
        { type: "mc", q: "I wake up in the ___.", options: ["morning", "evening", "night"], a: "morning" },
        { type: "mc", q: "I go to bed at ___.", options: ["night", "morning", "noon"], a: "night" },
        { type: "blank", q: "I start work in the ___. (morning)", options: ["morning"], a: "morning" },
        { type: "mc", q: "I finish work in the ___.", options: ["afternoon", "morning", "dawn"], a: "afternoon" },
        { type: "blank", q: "I watch TV in the ___. (evening)", options: ["evening"], a: "evening" },
        { type: "order", q: "Ordena: I sleep at night.", words: ["I", "sleep", "at", "night."], a: "I sleep at night." },
        { type: "mc", q: "Shower: Usually morning or evening. True?", options: ["True", "False"], a: "True" },
        { type: "blank", q: "I have lunch at ___. (noon)", options: ["noon"], a: "noon" },
        { type: "order", q: "Ordena: Good evening everyone.", words: ["Good", "evening", "everyone."], a: "Good evening everyone." }
      ]
    },
    // SET 8: Visual Routine (Rutina Visual - sin imágenes reales pero descriptivo)
    {
      id: "u12-set8",
      title: "Set 8: Describe the Action",
      questions: [
        { type: "match", q: "Match action to object", pairs: [{ left: "Brush", right: "Teeth" }, { left: "Drive", right: "Car" }, { left: "Cook", right: "Dinner" }], a: "completed" },
        { type: "mc", q: "Action: Sleeping in a bed. Phrase: ___", options: ["Go to sleep", "Wake up", "Get up"], a: "Go to sleep" },
        { type: "mc", q: "Action: Eating cereal. Phrase: ___", options: ["Have breakfast", "Have dinner", "Cook lunch"], a: "Have breakfast" },
        { type: "blank", q: "Action: Washing body. Phrase: Take a ___. (shower)", options: ["shower"], a: "shower" },
        { type: "mc", q: "Action: Working at a desk. Phrase: ___", options: ["Work", "Sleep", "Play"], a: "Work" },
        { type: "blank", q: "Action: Walking with a pet. Phrase: Walk the ___. (dog)", options: ["dog"], a: "dog" },
        { type: "order", q: "Ordena: She is sleeping.", words: ["She", "is", "sleeping."], a: "She is sleeping." },
        { type: "mc", q: "Action: Buying food. Phrase: Buy groceries. True?", options: ["True", "False"], a: "True" },
        { type: "blank", q: "Action: Cleaning teeth. Phrase: ___ teeth. (Brush)", options: ["Brush"], a: "Brush" },
        { type: "order", q: "Ordena: He is working.", words: ["He", "is", "working."], a: "He is working." }
      ]
    },
    // SET 9: Mixed Practice (Práctica Mixta)
    {
      id: "u12-set9",
      title: "Set 9: Routine Mix",
      questions: [
        { type: "mc", q: "Sequence: Wake up -> ___ -> Brush teeth.", options: ["Get up", "Sleep", "Dinner"], a: "Get up" },
        { type: "blank", q: "After work, I go ___. (home)", options: ["home"], a: "home" },
        { type: "mc", q: "I ___ lunch at 12:30.", options: ["have", "do", "go"], a: "have" },
        { type: "mc", q: "Before bed, I ___ my face.", options: ["wash", "watch", "walk"], a: "wash" },
        { type: "blank", q: "I need to ___ groceries today. (buy)", options: ["buy"], a: "buy" },
        { type: "order", q: "Ordena: I start work at 9.", words: ["I", "start", "work", "at", "9."], a: "I start work at 9." },
        { type: "mc", q: "Weekends are for relaxing. True?", options: ["True", "False"], a: "True" },
        { type: "blank", q: "I ___ the bus to school. (take)", options: ["take"], a: "take" },
        { type: "mc", q: "Routine means things you do every day. True?", options: ["True", "False"], a: "True" },
        { type: "order", q: "Ordena: Do you have a routine?", words: ["Do", "you", "have", "a", "routine?"], a: "Do you have a routine?" }
      ]
    },
    // SET 10: Full Review Challenge (Desafío Final)
    {
      id: "u12-set10",
      title: "Set 10: Routine Master",
      questions: [
        { type: "mc", q: "Complete morning: Wake up, get up, shower, ___.", options: ["breakfast", "dinner", "sleep"], a: "breakfast" },
        { type: "blank", q: "Complete evening: Home, cook, dinner, ___ dishes. (do)", options: ["do"], a: "do" },
        { type: "order", q: "Ordena: My daily routine is simple.", words: ["My", "daily", "routine", "is", "simple."], a: "My daily routine is simple." },
        { type: "mc", q: "Which is NOT a morning activity?", options: ["Go to sleep", "Wake up", "Breakfast"], a: "Go to sleep" },
        { type: "blank", q: "The sun sets at ___. (dusk)", options: ["dusk"], a: "dusk" },
        { type: "mc", q: "I finish work in the afternoon. True?", options: ["True", "False"], a: "True" },
        { type: "order", q: "Ordena: I brush my teeth twice.", words: ["I", "brush", "my", "teeth", "twice."], a: "I brush my teeth twice." },
        { type: "blank", q: "I ___ dressed in the morning. (get)", options: ["get"], a: "get" },
        { type: "mc", q: "Ready for the next unit? True?", options: ["True", "False"], a: "True" },
        { type: "order", q: "Ordena: Have a great day!", words: ["Have", "a", "great", "day!"], a: "Have a great day!" }
      ]
    }
  ]
};